import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=3cbe0eac&scoped=true"
import script from "./periodical.vue?vue&type=script&lang=js"
export * from "./periodical.vue?vue&type=script&lang=js"
import style0 from "./periodical.vue?vue&type=style&index=0&id=3cbe0eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe0eac",
  null
  
)

export default component.exports